// extracted by mini-css-extract-plugin
module.exports = {"bottomLine":"Index_bottomLine__1uhEo","paginate":"Index_paginate__UbnUv","list":"Index_list__2ECBE","item":"Index_item__13Xg-","active":"Index_active__1sSMr"};